<script>
import ListingModel from "@/views/Boarding/Components/ListingModel.vue";

export default {
    name: "OnBoardings",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel category="ON"></ListingModel>
</template>